import { render, staticRenderFns } from "./AreaSelector.vue?vue&type=template&id=e8947ed8&scoped=true&"
import script from "./AreaSelector.vue?vue&type=script&lang=ts&"
export * from "./AreaSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AreaSelector.vue?vue&type=style&index=0&id=e8947ed8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8947ed8",
  null
  
)

export default component.exports